// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__c4rqD","description":"NotFoundBlock_description__0KHEH"};